import { render, staticRenderFns } from "./CollectionSummary.vue?vue&type=template&id=54e66240&scoped=true"
import script from "./CollectionSummary.vue?vue&type=script&lang=js"
export * from "./CollectionSummary.vue?vue&type=script&lang=js"
import style0 from "./CollectionSummary.vue?vue&type=style&index=0&id=54e66240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e66240",
  null
  
)

export default component.exports